import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  audioWrapper: {
    // width: '100%',
    display: 'flex'
    // justifyContent: 'flex-end',
  },
  audioPlayer: {
    width: props => (props.variant === 'compact' ? '200px' : '350px'),
    maxWidth: '100%',
    borderRadius: '8px',
    backgroundColor: 'transparent', // Dark background color
    padding: props =>
      props.variant === 'compact' ? '0' : '0 6px 10px 6px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0px',
    position: 'relative',
    transition: 'all 0.3s ease',
  },

  compactPlayer: {
    height: '32px', // Altura reduzida
    marginBottom: '0px'
  },

  audioPlayerRight: {
    backgroundColor: 'transparent',
    '& $waveBar': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      '&.played': {
        backgroundColor: theme.palette.blue_300.main
      }
    },
    '& $playButton': {
      color: theme.palette.blue_300.main
    },
    '& $timeDisplay, & $durationDisplay': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main // Lighter green text
    }
  },
  playerControls: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  playButton: {
    backgroundColor: 'transparent',
    color: theme.palette.blue_300.main,
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    padding: 0,
    marginRight: props => (props.variant === 'compact' ? '4px' : '8px'),
    display: 'flex',
    '&:hover': {
      opacity: 0.9
    }
  },
  downloadButton: {
    backgroundColor: 'transparent',
    color: theme.palette.gray_400.main,
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    padding: '4px',
    marginLeft: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }
  },
  waveformContainer: {
    flex: 1,
    height: props => (props.variant === 'compact' ? '20px' : '30px'),
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    marginRight: props => (props.variant === 'compact' ? '6px' : '12px')
  },
  waveformBackground: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center'
  },
  waveBar: {
    height: '2px',
    backgroundColor: '#6b6b6b', // Inactive waveform color
    width: '1px',
    margin: '0 1px',
    borderRadius: '1px',
    '&.tall': {
      height: '14px'
    },
    '&.medium': {
      height: '10px'
    },
    '&.small': {
      height: '6px'
    },
    '&.played': {
      backgroundColor: theme.palette.blue_300.main // Active waveform color
    }
  },
  timeDisplay: {
    fontSize: '12px',
    color: '#909090',
    marginRight: '8px',
    userSelect: 'none',
    minWidth: '35px'
  },
  durationDisplay: {
    fontSize: '12px',
    color: '#909090',
    userSelect: 'none',
    minWidth: '40px'
  },
  profileImage: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '1px solid #444'
  },
  // Estilização para o check mark de mensagem enviada
  ackIcons: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  ackDoneAllIcon: {
    color: theme.palette.green_whatsApp.main
  }
}))
